const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  logo: {
    height: '30px',
    marginBottom: theme.spacing(1),
  },
  text: {
    fontWeight: theme.typography.fontWeightMedium,
  },
})

export default styles
